module.exports = __webpack_public_path__ + "static/media/logo.65d6968e.svg";